import { app } from "@/modules/app";

import './root';

import '../pages/fortune/routes';
import '../pages/notice/routes';
import '../pages/offer/routes';
import '../pages/review/routes';
import '../pages/shop/routes';
import './auth';
import './front';
import './pages';
import './personal';
import './push';
import './pwa';

const routes = app.buildRoutes()

export default routes
